import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getLabelDetailList = createAsyncThunk(
  "labelDetailList/getLabelDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/label/get_all_data`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const labelDetailSlice = createSlice({
  name: "labelDetailList",
  initialState: {
    loading: false,
    labelDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLabelDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLabelDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.labelDetailData = action.payload;
      })
      .addCase(getLabelDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default labelDetailSlice.reducer;
